import axios from 'axios';
import {push} from 'react-router-redux';
import {ROOT_URL} from '../../config';
import {
    beginAjaxCall,
    endAjaxCall,
    setUploadProgress
} from '../../containers/layout/actions';
import {signOut} from '../../containers/auth/actions';
import {errors_popup} from '../helpers/helpers';
import swal from 'sweetalert';

const request = async (options, dispatch) => {
    dispatch(beginAjaxCall());

    const client = axios.create({
        baseURL: ROOT_URL,
        headers: {
            authorization: "Bearer " + localStorage.getItem('token')
        }
    });

    const onSuccess = response => {
        dispatch(endAjaxCall());
        return response;
    };

    const onError = error => {
        dispatch(endAjaxCall());

        if (error.response) {
            if (error.response.data.error === "token_expired") {
                dispatch(signOut())
            }
        }
        
        let errStr = errors_popup(error);

        swal("There were some errors", errStr, "error")

        if (error.response.statusText === "Forbidden") {
            swal("There were some errors", errStr, "error")
            .then(() => {
                dispatch(push(`/dashboard`))
            });
        }

        return Promise.reject(error.response || error.message);
    };

    return client(options)
        .then(onSuccess)
        .catch(onError);
};

export const uploadImages = (dispatch, images, prefix, siteId, success, error) => {
    if (Object.keys(images).length === 0) {
        success(true);
    } else {
        dispatch(beginAjaxCall());
        dispatch(setUploadProgress(0));
    
        let data = new FormData();
    
        let indexes = '';
    
        data.append('prefix', prefix);
    
        for (let i in images) {
            indexes += i + '|';
            data.append('images_' + i, images[i].image.imageObject);
            data.append('images_cropped_' + i, images[i].image.croppedImageObject);
            data.append('images_cropped_thumb_' + i, images[i].image.croppedImageThumbObject);
        }
    
        data.append('indexes', indexes);
        data.append('site_id', siteId);

        axios.post(`${ROOT_URL}/images-bulk`, data, {
            onUploadProgress: function (progressEvent) {
                let percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                dispatch(setUploadProgress(percentCompleted));
                console.log('Upload progress: ' + percentCompleted + '%');
            },
            headers: {
                authorization: "Bearer " + localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            response => {
                success(response);
                dispatch(endAjaxCall());
                dispatch(setUploadProgress(null));
            }
        ).catch(err => {
            error(err);
            dispatch(endAjaxCall());
        });
    }
};

export const uploadImage = (dispatch, image, prefix, siteId, success, error) => {
    if (!image) {
        success(true);
    } else if (!image.image) {
        success(true);
    } else if (!image.image.imageObject) {
        success(true);
    } else {
        dispatch(beginAjaxCall());
        dispatch(setUploadProgress(0));
        let data = new FormData();
        data.append('prefix', prefix);
        data.append('image', image.image.imageObject);
        data.append('image_cropped', image.image.croppedImageObject);
        data.append('site_id', siteId);

        axios.post(`${ROOT_URL}/images`, data, {
            onUploadProgress: function (progressEvent) {
                let percentCompleted = Math.round(
                   (progressEvent.loaded * 100) / progressEvent.total
                );
                dispatch(setUploadProgress(percentCompleted));
                console.log('Upload progress: ' + percentCompleted + '%');
            },
            headers: {
                authorization: "Bearer " + localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            response => {
                success(response);
                dispatch(endAjaxCall());
                dispatch(setUploadProgress(null));
            }
        ).catch(err => {
            if (error === undefined) {
                let errStr = errors_popup(err);
                swal("There were some errors", errStr, "error");
            } else {
                error(err);
            }
            dispatch(endAjaxCall());
        });
    }
};

export const uploadDocument = (dispatch, docs, siteId, success, error) => {
    if (Object.keys(docs).length === 0) {
        success(true);
    } else {
        dispatch(beginAjaxCall());
        dispatch(setUploadProgress(0));
    
        let data = new FormData();
        let indexes = '';

        data.append('prefix', 'product');
        data.append('site_id', siteId);
        
        for (let i in docs) {
            if (docs[i].document.documentObject) {
                indexes += i + '|';
                data.append('documents_' + i, docs[i].document.documentObject);
            }
        }
    
        data.append('indexes', indexes);

        axios.post(`${ROOT_URL}/documents-bulk`, data, {
            onUploadProgress: function (progressEvent) {
                let percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                dispatch(setUploadProgress(percentCompleted));
                console.log('Upload progress: ' + percentCompleted + '%');
            },
            headers: {
                authorization: "Bearer " + localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            response => {
                success(response);
                dispatch(endAjaxCall());
                dispatch(setUploadProgress(null));
            }
        ).catch(err => {
            error(err);
            dispatch(endAjaxCall());
        });
    }
};

export const uploadBulkRedirects = (dispatch, doc, success, error) => {
        dispatch(beginAjaxCall());
        dispatch(setUploadProgress(0));
        let data = new FormData();
        data.append('csvFile', doc);

        axios.post(`${ROOT_URL}/redirects-bulk-update`, data, {
            onUploadProgress: function (progressEvent) {
                let percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                dispatch(setUploadProgress(percentCompleted));
                console.log(percentCompleted);
            },
            headers: {
                authorization: "Bearer " + localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            response => {
                success(response);
                dispatch(endAjaxCall());
                dispatch(setUploadProgress(null));
            }
        ).catch(err => {
            if (error === undefined) {
                let errStr = errors_popup(err);
                swal("There were some errors", errStr, "error");
            } else {
                error(err);
            }
            dispatch(endAjaxCall());
        });
};

export default request;


// WEBPACK FOOTER //
// ./src/components/api/api.js